export class NumberUtils {
	public static valueFromPercentage(percent: number, totalValue: number, decimals?: number) {
		const value =  (percent / 100) * totalValue;

		if (!decimals || !value) {
			return value;
		}

		return Math.round(value * Math.pow(10, decimals)) / Math.pow(10, decimals);

	}

	public static toPercentage(value: number, total: number, decimals?: number) {
		if (!value || !total) {
			return value
		}

		const percentage = (value * 100) / total;

		if (!decimals || !percentage) {
			return percentage;
		}

		return Math.round(percentage * Math.pow(10, decimals)) / Math.pow(10, decimals);
	}

	/**
	 * Ensures a number is represented as a string with a decimal point, even if it's a whole number
	 * Examples:
	 * - ensureFloatString(0) -> "0" (does not really matter if a zero is a float or an integer)
	 * - ensureFloatString(52) -> "52.0"
	 * - ensureFloatString(52.3) -> "52.3"
	 * - ensureFloatString("52") -> "52.0"
	 * - ensureFloatString("52.3") -> "52.3"
	 * @param value
	 */
	public static ensureFloatString(value: number | string): string | null {
		if (value === '') {
			return value;
		}

		const numValue = typeof value === 'string' ? parseFloat(value) : value;
		const isValidNumber = !isNaN(numValue) && isFinite(numValue);

		// If not valid, return as-is
		if ((!numValue || !isValidNumber) && numValue !== 0) {
			if (typeof value === 'string') {
				return value;
			} else {
				return null;
			}
		}

		// If it's already a decimal, return as-is
		if (numValue % 1 !== 0 || numValue === 0) {
			return numValue.toString();
		}

		// If a whole number. make sure to add .0
		return numValue.toString() + '.0';
	}
}
